<template>
    <div>
        <b-button :id="uuid" :variant="btnVariant" :class="btnClass" :disabled="btnDisable"
                  @click="$emit('btnClick')">
            <i v-if="btnIcon" :class="btnIcon"></i>
            <div v-else>{{ title }}</div>
            <slot name="button"></slot>
        </b-button>
        <b-popover :target="uuid" :triggers="clickTrigger ? 'click' : (trigger ? trigger : 'hover')"
                   :placement="popupPlacement" boundary="window"
                   :show="show"
                   @shown="whenPopoverShown"
                   @hide="whenPopoverHide">
            <slot></slot>
        </b-popover>
    </div>
</template>

<script>
import emCommonUtilMixin from "@/mixin/em/common/stuffs/utils/emCommonUtilMixin";

export default {
    name: "OverlayPop",
    mixins: [emCommonUtilMixin],
    props: {
        btnVariant: String,
        btnIcon: String,
        btnClass: String,
        btnDisable: {
            type: Boolean,
            default: false
        },
        title: String,
        clickTrigger: {
            type: Boolean,
            default: false
        },
        trigger: [String, Array],
        popupPlacement: String,
        show: Boolean
    },
    computed: {
        uuid() {
            return this.genNonDuplicateID(5);
        },
    },
    methods: {
        whenPopoverShown() {
            this.$emit('shown');
        },
        whenPopoverHide() {
            this.$emit('hide');
        },
    }
}
</script>

<style scoped>

</style>
